import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import './Howimportsworkpage4.css';
import stepspage4 from './images/stepspage4.png';

const Howimportsworkpage4 = () => {
    return (
        <>
        <div className="how-imports-work-section">
            <div className="container">
                <div className="row align-items-center" style={{ minHeight: "100vh" }}>
                    <h1 className="how-imports-work-text">Ways to Bring Goods to India from China 
                        <br/>Let's investigate the entire importation process from China to India.What information do you need?</h1>
                </div>
            </div>
        </div>
        <br/>

        <div className="container my-4">
            <div className="text-center">
                <h2 className="how-imports-heading">The Best Way to Successfully Import from China to India </h2>
                <br/>
            </div>

            <div className="p-4 my-4 how-to-success">
                <h5 className="how-import-head text-center py-2">How to Successfully Import to India from China!</h5>
                <p className="how-import-text py-2 text-start">For many companies, importing to India from China has proven to be an effective global sourcing strategy. 
                    You have a great chance here as a reseller and buyer.  The question that every novice or first-timer has been asking is how to properly import items from 
                    China through India.  
                </p>
                <p className="how-import-text text-start">Importing can be a very expensive, complicated, and perplexing process.  Long transit times, rising or fluctuating delivery costs, 
                    regulatory fees, and unforeseen delays can often negate intended gains.  Don't heed to the horror stories if quality is a concern.  
                    You shouldn't have any issues as long as you take the time to speak with your supplier, research their track record, request a sample, and 
                    place a small purchase initially. The best ways to get in touch with suppliers are by phone or chat on instant messaging.  Email is also OK, 
                    but if the supplier uses it, a phone call or instant messaging will provide you with responses more quickly.
                </p>
                <p className="how-import-text text-start">This is a step-by-step guide based on our experience importing from China since 2006, when we worked as import consultants and import agents for 
                    Chinese exporters and importers all over the world.  Let's look at how to import goods into India from China and what you can do to help the 
                    process run more smoothly.
                </p>
            </div>
            
            <div className="text-center">
            <h2 className="how-imports-heading py-2">How the Import Process Operates: A Comprehensive Guide  </h2>
            <br/>
            <br/>
            <img src={stepspage4} alt="stepspage4" />
            </div>
            <br/>
            <br/>
            <br/>

            <h2 className="how-imports-heading text-start">FOR ALL YOU NEED TO SUCCESSFULLY IMPORT FROM CHINA, WE ARE A ONE-STOP IMPORT SOLUTION.  ENOUGH TIME FOR YOU TO WORK ON YOUR PRIMARY BUSINESS.</h2>
            <p className="how-import-text">Export permits, import paperwork, quality control, product inspection, sourcing, purchasing, and negotiation, payment (you won't have to deal with currency transfers), customs clearance, and hassle-free goods delivery to your door.</p>
            <br/>
            <h2 className="how-imports-heading text-center">How Can I Source the Supplier Myself?</h2>
            <h2 className="how-imports-heading text-center">Source Suppliers from the following websites:</h2>
            <br/>
            <ul>
                <strong className="how-import-points"><li>Negotiate: </li></strong>
                <p className="how-import-text">Getting the best bargain is the next step after narrowing down your supplier list.  To ensure that every standard is covered in the sales contract, we advise you to haggle over the price and quality.  To revalidate the transaction, kindly email us this sales contract or proforma invoice.</p>
                
                <strong className="how-import-points"><li>Place Order: </li></strong>
                <p className="how-import-text">Verifying the order is the next stage.  Once we have received your payment, we will proceed to process the transaction.  Rest assured that your money is safe with us; we'll explain how we protect it in the next step</p>

                <strong className="how-import-points"><li>Secure Payment: </li></strong>
                <p className="how-import-text">In order to validate your transaction, we will first verify the supplier's credentials. If our staff is happy, we will then send them the deposit or advance.  (The deposit might be between 20% and 50%.)  We require a deposit of no more than 30% in order to effectively manage your order.  Your 70% payment is still securely held by us.</p>

                <strong className="how-import-points"><li>Inspection: </li></strong>
                <p className="how-import-text">Our skilled staff will examine the products when the order is prepared for shipping (straight from the factory, fulfilment centre, or warehouse) and provide you any requested images, videos, or test results.  For the majority of large purchases, we will charge you 3% for inspection.  For information on the inspection charge for small and medium orders, please get in touch with us.</p>

                <strong className="how-import-points"><li>Delivery: </li></strong>
                <p className="how-import-text">Following your satisfaction with the product, we pay the supplier the remaining amount and send the items to you by mixed container service, LCL, FCL, etc.</p>
            </ul>
            <br/>
            <br/>

            <h5 className="how-import-head text-center">Here is a brief summary of the key ideas covered in this guide: </h5>
            <h5 className="how-import-head text-center"> How to Ship Goods to India from China </h5>
            <br/>
            <ul className="how-import-last-points">
                <li>When you import from China during its growth time, you have the chance to purchase cheap and sell cheap.</li>
                <li>China produces the majority of the world's consumer goods, so don't believe the horror stories about their low quality!</li>
                <li>Avoid purchasing designer-branded goods from Chinese vendors as they are most likely counterfeit.</li>
                <li>Consult your local customs office before importing to see if there are any restrictions on the goods you plan to import.</li>
                <li>Compare prices or haggle over shipping charges.</li>
            </ul>
        </div>
        </>
    )
}

export default Howimportsworkpage4;